import { ActionTypes } from '../constants/index';

export const channelNotificationDetail = (payload: any) => ({
  type: ActionTypes.CHANNEL_NOTIFICATION_DETAIL_REQUEST,
  payload,
});
